import { showLogic, showLogicWithUbo } from '../../../logic/show';
export var showGsmPrincipalLogic = showLogic;
export var showGsmPrincipalConfirmLogic = showLogic;
export var showEmailPrincipalLogic = showLogicWithUbo;
export var showEmailPrincipalConfirmLogic = showLogic;
export var showLandlineLogic = showLogic;
